import { error } from '../Log'

/* eslint-disable no-underscore-dangle */
export default function listrakProductBrowse(sku: string) {
  try {
    const listrak = window?._ltk
    listrak?.Activity?.AddProductBrowse?.(sku)
  } catch (err) {
    error('Failed to send browseProduct to listrak', err)
  }
}
